





















import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryGoodsList,QueryGoodsCounts, BatchRemoveIndexGoods, BatchAddIndexGoods, UpdateGoodsStatus, QuerySupplierList, QueryAllShopNameList ,BatchUpdateGoodsStatus} from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import CreateGoodsDialog from './CreateGoodsDialog.vue'
import UpdateGoodsDialog from './UpdateGoodsDialog.vue'
import DescGoodsDialog from './DescGoodsDialog.vue'
import { getNameById } from '@/store/classifyStore'
import {PriceFormat,GoodsStatusFormat} from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import {getUser} from '@/store/userStore'
import SelectGoodsDialog from '@/components/goods/SelectGoodsDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    CreateGoodsDialog,
    UpdateGoodsDialog,
    DescGoodsDialog,
    SelectGoodsDialog
  },
})
export default class GoodsList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    sortType: 0,
    indexGoods: true,
  }
  private goodsCounts = {
    saleingCount:0,
    saleOverCount:0,
    putDownCount:0,
    auditCount: 0,
    auditErrorCount: 0,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private activeMenu = 'ALL'

  private supplierOption: Array<any> = []
  private shopIdOption: Array<any> = []
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}
  private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption,show:()=>{return this.userInfo.user.role != 2}}

  private  userInfo = getUser()
  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '排序方式', param: 'sortType' , type: 'select', selectData: constant.SortType},
    // this.supplierQueryParam,
    this.shopIdQueryParam,
    { title: '商品名称', param: 'goodsName' },
    { title: '商品编号', param: 'goodsCode' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '添加商品', type: 'primary', click: this.addGoods },
    // { title: '批量上架', type: 'primary', click: this.batchUpp },
    // { title: '批量下架', type: 'primary', click: this.batchDown },
    { title: '批量移除首页', type: 'danger', click: this.batchRemoveIndex },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    // { title: '供应商编号', param: 'supplierCode' },
    { title: '店铺', param: 'shopId' ,formatter: this.shopNameForam, overflow: true,hide:this.userInfo.user.role == 2},
    { title: '商品编号', param: 'goodsCode' , overflow: true,width:200},
    { title: '商品名称', param: 'goodsName' , overflow: true,width:200},
    { title: '商品图片', param: 'goodsBanners' , width: 80 , type:'image', formatter: this.getGoodsBanner },
    { title: '一级分类', param: 'goodsOneClassifyId' , formatter: getNameById},
    { title: '二级分类', param: 'goodsTwoClassifyId' ,formatter: getNameById},
    { title: '三级分类', param: 'goodsThreeClassifyId' ,formatter: getNameById},
    // { title: '标签', param: 'goodsLabel' },
    // { title: '单位', param: 'goodsUnit' },
    { title: '销售价', param: 'showPrice' ,formatter: this.showPriceFormat},
    // { title: '奖励积分', param: 'rewardIntegral' ,formatter: PriceFormat},
    { title: '市场价', param: 'marketPrice' ,formatter: PriceFormat},
    { title: 'PV', param: 'minPv' ,formatter: this.showPvFormat},
    // { title: '贡献值', param: 'profferValue' ,formatter: PriceFormat},
    // { title: '能力值', param: 'capacityValue' ,formatter: PriceFormat},
    { title: '库存', param: 'inventory' },
    { title: '状态', param: 'goodsStatus' ,formatter: GoodsStatusFormat},
    { title: '排序', param: 'sort' ,hide:this.userInfo.user.role == 2},
    { title: '创建时间', param: 'createTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      width: 180,
      fixed: 'right',
      operation: [
        { title: '编辑', icon: 'el-icon-edit',click: this.openUpdate },
        { title: '移除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    console.log(e)
    this.tableSelectData = e
  }

  public batchUpp(){
    if(this.tableSelectData.length<=0){
        this.$message.error("请选择商品")
        return
    }
    MessageBox.confirm('确定要上架吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchUpdateGoodsStatus({ idList: this.tableSelectData.map(item=>item.id), goodsStatus: 1 })
      if (ruslt) {
        Message.success('上架成功')
        this.loadData()
      }
    })
  }

    public batchRemoveIndex() {
       if(this.tableSelectData.length<=0){
        this.$message.error("请选择商品")
        return
    }
    MessageBox.confirm('确定要将选择的商品移除首页吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchRemoveIndexGoods({ idList: this.tableSelectData.map(item=>item.id) })
      if (ruslt) {
        Message.success('移除成功')
        this.loadData()
      }
    })
  }

  public batchAddIndexGoods(d: any){
    if(!d || d.length == 0){
      return
    }
    const idList = d.map((e: any)=>e.id)
    BatchAddIndexGoods({idList}).then(res=>{
      if(res){
        this.$message.success("添加成功")
        this.loadData()
      }
    })
  }

  public async created() {
    this.loadData()
    // await this.loadSupplier()
    this.loadShop()
  }

  private activeMenuSelect(e:string){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    this.search()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption

  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  private getGoodsBanner(value: string){
    if(value){
      const vs = value.split(",")
      console.log("vs")
      console.log(vs)
      return vs[0]
    }
    return ""
  }

  public addGoods() {
    (this.$refs.SelectGoodsDialog as SelectGoodsDialog).open()
    // this.$router.push("/createGoodsPage")
  }
  public openUpdate(data: any) {
    (this.$refs.createGoodsDialog as CreateGoodsDialog).open('update',data.goodsCode)
  }
  public openDesc(data: any){
    (this.$refs.descGoodsDialog as DescGoodsDialog).open(data.goodsCode)
  }
  public shangjia(data: any){
    MessageBox.confirm('确定要上架吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsStatus({ id: data.id, goodsStatus: 1 })
      if (ruslt) {
        if(this.userInfo.user.shop && !this.userInfo.user.shop.directSales){
          Message.success('已提交上架审核')
        } else {
          Message.success('上架成功')
        }
        this.loadData()
      }
    })
  }
  public xiajia(data: any){
    MessageBox.confirm('确定要下架吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsStatus({ id: data.id, goodsStatus: 0 })
      if (ruslt) {
        Message.success('下架成功')
        this.loadData()
      }
    })
  }

  public chexiao(data: any){
    MessageBox.confirm('确定要撤销吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsStatus({ id: data.id, goodsStatus: 0 })
      if (ruslt) {
        Message.success('撤销成功')
        this.loadData()
      }
    })
  }

  public async loadData() {
    // 排序
    const param: any = { ...this.queryParam }
    if(this.queryParam.sortType == 0){
      param.orderBy = "sort desc, create_time desc"
    }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)

    // 根据选择菜单的不同查询不同的数据
    if(this.activeMenu == 'Saleing'){
      // 售卖中
      param.goodsStatus = 1
       param.inventoryGe = 1
    } else if(this.activeMenu == 'SaleOveer'){
      // 已售罄
      param.goodsStatus = 1
      param.inventory = 0
    } else if(this.activeMenu == 'PutDown'){
      // 已下架
      param.goodsStatus = 0
    } else if(this.activeMenu == 'auditCount'){
      // 审核中
      param.goodsStatus = 2
    }  else if(this.activeMenu == 'auditErrorCount'){
      // 审核失败
      param.goodsStatus = 3
    }

    const result = await QueryGoodsList(param)
    this.tableTotal = result.total
    this.tableData = result.list

    const res2 = await QueryGoodsCounts(param)
    this.goodsCounts = res2
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    MessageBox.confirm('确定要将商品移除首页吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchRemoveIndexGoods({ idList: [data.id] })
      if (ruslt) {
        Message.success('移除成功')
        this.loadData()
      }
    })
  }
  // 显示价格
  private showPriceFormat(v:any,row:any){
    let showPrice = ''
    if(row.minPrice == row.maxPrice){
      showPrice = PriceFormat(row.minPrice)
    } else {
      showPrice = PriceFormat(row.minPrice) + '~' + PriceFormat(row.maxPrice)
    }
    return showPrice
  }
  // 显示Pv
  private showPvFormat(v:any,row:any){
    let showPv = ''
    if(row.minPv == row.maxPv){
      showPv = PriceFormat(row.minPv)
    } else {
      showPv = PriceFormat(row.minPv) + '~' + PriceFormat(row.maxPv)
    }
    return showPv
  }
  // 显示店铺名称
  private shopNameForam(v:number){
    const t = this.shopIdOption.find(e=>e.value == v)
    if(t){
      return t.label
    }
    return v
  }
}
